import type { ShortDaysOfWeek } from '@brighterly/lib-core-types/options/enums'
import type { TutorAvailability } from '@brighterly/lib-core-types/discipline/types'
import type { ScheduleStore, WeeklyScheduleSlot } from './interfaces'
import type { ScopeStatus } from '@utils/stores/scoped-entry'

import { useDisciplineStore } from '@stores/discipline'

import { entryData, entryStatus } from '@utils/stores/scoped-entry'

const getAvailability = (state: ScheduleStore): TutorAvailability | null =>
  entryData(state.availabilityById, useDisciplineStore().activeDiscipline?.id ?? null)

export const getters = {
  isModalSchedule: (state: ScheduleStore): boolean => state.modalSchedule,
  isModalRescheduleSuccess: (state: ScheduleStore): boolean => state.modalScheduleSuccess,
  isModalConfirmWeeklySchedule: (state: ScheduleStore): boolean => state.modalConfirmWeeklySchedule,
  isLoading: (state: ScheduleStore): boolean => state.loading,
  availableDates: (state: ScheduleStore): string[] => state.availableSlots.map(slot => slot.day),
  selectedDateSlots: (state: ScheduleStore): string[] => {
    if (!state.selectedDate) return []
    const found = state.availableSlots.find(slot => slot.day === state.selectedDate)
    return found ? found.slots : []
  },
  isFormValid: (state: ScheduleStore): boolean => {
    return !!(state.selectedDate && state.selectedTime)
  },
  getAvailability: (state: ScheduleStore): TutorAvailability | null => getAvailability(state),
  isAvailability: (state: ScheduleStore): boolean => !!getAvailability(state),
  getAvailabilityStatus: (state: ScheduleStore) => (id: number | null): ScopeStatus => entryStatus(state.availabilityById, id),
  getWeeklySchedule: (state: ScheduleStore): WeeklyScheduleSlot[] => {
    return state.weeklySchedule
  },
  getSelectedDays: (state: ScheduleStore): ShortDaysOfWeek[] => {
    return state.selectedDays
  },
  getShowErrors: (state: ScheduleStore): boolean => state.showErrors,
}
